import * as React from 'react';

import classnames from 'classnames';

import type {GetPlanComparisons_planComparisons_planStubs as PlanStub} from 'nutshell-graphql-types';

import {Body} from '../../typography/body';

import {getIconByKey} from '../helpers';

import styles from './plan-comparison-table.module.css';

type Props = {
    plans: PlanStub[];
};

const buildPriceString = (plan: PlanStub): string | React.ReactNode => {
    if (plan.price === null) {
        return plan.priceUnit;
    }

    return (
        <>
            <strong>${plan.price}</strong> {plan.priceUnit}
        </>
    );
};

// Sticky header at the top of the table, contains the plan badges
export function PlanComparisonTableHeader(props: Props): React.ReactElement {
    return (
        <thead className={styles['sticky-header']}>
            <tr className='py-8'>
                <td
                    className={classnames(
                        styles['table-cell--feature-group-title'],
                        styles['header-cell-border']
                    )}
                ></td>
                {props.plans.map((plan) => {
                    return (
                        <td
                            key={plan.key}
                            className={classnames(
                                styles['table-cell--feature-badge'],
                                styles['header-cell-border']
                            )}
                        >
                            <div className='flex flex-dir-col align-center justify-center gap-4'>
                                {getIconByKey(plan.key)}
                                <Body>{buildPriceString(plan)}</Body>
                            </div>
                        </td>
                    );
                })}
            </tr>
        </thead>
    );
}
